<app-loading *ngIf="contentReady"></app-loading>
<div class="container mt-3 full-product" style="margin-bottom: 80px;">

  <!-- عنوان المنتج -->
  <h6 class="text-primary pointer" (click)="bybrand(this.brandid)">

    {{brandname}}

  </h6>
  <h5>
    @if(isAr){
    {{product?.name_ar}}
    }
    @else{
    {{product?.name_en}}
    }
  </h5>

  <!-- صورة المنتج -->
  <div class="product-img">
    @if(calcDis(product?.is_daily_offer?product?.affiliationprice:product?.pricea,product?.pricec) != 0){
    <div class="discountbadge">
      {{calcDis(product?.is_daily_offer?product?.affiliationprice:product?.pricea,product?.pricec)}} % {{ "discount" |
      transloco }}</div>
    }
    @if(
    product?.is_daily_offer){
    <div class="daily-offer-badge">
      <span style="font-size: 10px;">
        @if(product?.is_daily_offer){
        {{ "saveuptotext" | transloco }}
        }
      </span>
      <div class="chip-timer" [class.alert-error-text]="(dailyOfferState.progress$ | async)! <= 80">
        {{ dailyOfferState.timer$ | async }}
      </div>
    </div>

    }
    @if(product?.image != null)
    {
    <div class="col-12 ">
      @if(product?.pet == '0'){
      <img class="product-img" [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(product?.image)"
        [errorImage]="'/assets/noproduct cat.webp'" alt="product" />
      }
      @else{
      <img class="product-img" [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(product?.image)"
        [errorImage]="'/assets/noproduct dog.png'" alt="product" />
      }

    </div>
    }
    @else{
    <div>
      @if(product?.pet == '0'){

      <img class="product-img" src="/assets/noproduct cat.webp">
      }
      @else{

      <img class="product-img" src="/assets/noproduct dog.png">
      }

    </div>
    }

  </div>

  <!-- التقييم + السعر -->
  <div class="d-flex align-items-center justify-content-between">
    <!-- <div>
            <span class="text-warning">★ 4.8</span>
        </div> -->
    <div>
      <span class="new-price">{{product?.is_daily_offer?product?.affiliationprice:product?.pricea}} {{ "egpe" |
        transloco
        }}</span>
      @if(calcDis(product?.is_daily_offer?product?.affiliationprice:product?.pricea,product?.pricec) != 0){
      <span class="old-price">{{product?.pricec}} {{ "egpe" | transloco }}</span>
      }
    </div>
  </div>

  <!-- التابات -->
  <div class="tabs mt-4">
    <button class="active"> {{ "productdetails" | transloco }}</button>
  </div>

  <p class="mt-2 product-info">
    <ng-container [ngSwitch]="product?.pet">
      <span *ngSwitchCase="'0'">
        <img src="/assets/e-commerce/icons/8.webp">
        {{ "cats" | transloco }}
      </span>
      <span *ngSwitchCase="'1'">
        <img src="/assets/e-commerce/icons/11.webp">
        {{ "dogs" | transloco }}
      </span>
      <span *ngSwitchCase="'2'">
        <img src="/assets/e-commerce/icons/13.webp">
        {{ "birds" | transloco }}
      </span>
      <span *ngSwitchCase="'4'">
        <img src="/assets/e-commerce/icons/10.webp">
        {{ "cats&dogs" | transloco }}
      </span>
      <span *ngSwitchCase="'3'">
        <img src="/assets/e-commerce/icons/25.png">
        {{ "other" | transloco }}
      </span>
    </ng-container>

    <ng-container [ngSwitch]="product?.category_id">
      <span *ngSwitchCase="'0'">
        <img src="/assets/e-commerce/icons/18.webp">
        {{ "soft food" | transloco }}
      </span>
      <span *ngSwitchCase="'1'">
        <img src="/assets/e-commerce/icons/17.webp">
        {{ "soft food can" | transloco }}
      </span>
      <span *ngSwitchCase="'2'">
        <img src="/assets/e-commerce/icons/23.webp">
        {{ "dry food" | transloco }}
      </span>
      <span *ngSwitchCase="'3'">
        <img src="/assets/e-commerce/icons/31.webp">
        {{ "bird food" | transloco }}
      </span>
      <span *ngSwitchCase="'4'">
        <img src="/assets/e-commerce/icons/29.webp">
        {{ "medicine" | transloco }}
      </span>
      <span *ngSwitchCase="'5'">
        <img src="/assets/e-commerce/icons/27.webp">
        {{ "supplement" | transloco }}
      </span>
      <span *ngSwitchCase="'6'">
        <img src="/assets/e-commerce/icons/26.webp">
        {{ "accessories" | transloco }}
      </span>
      <span *ngSwitchCase="'7'">
        <img src="/assets/e-commerce/icons/24.webp">
        {{ "toy" | transloco }}
      </span>
      <span *ngSwitchCase="'8'">
        <img src="/assets/e-commerce/icons/25.webp">
        {{ "grooming" | transloco }}
      </span>
      <span *ngSwitchCase="'9'">
        <img src="/assets/e-commerce/icons/28.webp">
        {{ "house" | transloco }}
      </span>
      <span *ngSwitchCase="'10'">
        <img src="/assets/e-commerce/icons/30.webp">
        {{ "care" | transloco }}
      </span>
      <span *ngSwitchCase="'11'">
        <img src="/assets/e-commerce/icons/32.webp">
        {{ "treats" | transloco }}
      </span>
      <span *ngSwitchCase="'12'">
        <img src="/assets/e-commerce/icons/19.webp">
        {{ "training pads" | transloco }}
      </span>
      <span *ngSwitchCase="'13'">
        <img src="/assets/e-commerce/icons/34.webp">
        {{ "bags" | transloco }}
      </span>
      <span *ngSwitchCase="'14'">
        <img src="/assets/e-commerce/icons/33.webp">
        {{ "cleaning tools" | transloco }}
      </span>
      <span *ngSwitchCase="'15'">
        <img src="/assets/e-commerce/icons/20.webp">
        {{ "litter" | transloco }}
      </span>
    </ng-container>

    <!-- <ng-container [ngSwitch]="product?.pet_type">
            <span *ngSwitchCase="'0'">

                {{ "adult" | transloco }}
            </span>
            <span *ngSwitchCase="'1'">

                {{ "kitten" | transloco }}
            </span>
            <span *ngSwitchCase="'2'">

                {{ "sterilized" | transloco }}
            </span>
            <span *ngSwitchCase="'3'">

                {{ "persian" | transloco }}
            </span>
            <span *ngSwitchCase="'4'">

                {{ "puppy" | transloco }}
            </span>
            <span *ngSwitchCase="'5'">

                {{ "birds" | transloco }}
            </span>
            <span *ngSwitchCase="'6'">

                {{ "other" | transloco }}
            </span>
        </ng-container> -->


    <br>
    @if(isAr){
    {{product?.name_ar}}
    }
    @else{
    {{product?.name_en}}
    }
    <br>
    {{branddisc}}
  </p>
  <div class="rating-summary" *ngIf="avgRating > 0">
    <span>
      <svg class="star-svg" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg> {{ roundedRating }} / 5
    </span>
    <small>({{ ratingsCount }} {{ "rate" | transloco }})</small>
  </div>
  <div class="star-rate mt-2">
    <i *ngFor="let s of [1,2,3,4,5]" class="star" [class.active]="s <= userStars"
      (click)="tokenExists?rateProduct(s):null">
      <svg class="star-svg" viewBox="0 0 24 24">
        <path fill="currentColor"
          d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    </i>
  </div>
  <div class="comment-box mt-3">

    @if(tokenExists){
    <textarea [(ngModel)]="newComment" placeholder="{{ 'Write your opinion about the product' | transloco }}"
      class="form-control">
  </textarea>
    <button class="btn btn-add mt-2" (click)="addComment()">
      {{ "add comments" | transloco }}
    </button>
    }

  </div>
  <div class="comments-list mt-4" *ngIf="comments.length">
    <div class="tabs mt-4">
      <button class="active"> {{ "comments" | transloco }}</button>
    </div>


    <div class="comment-item" *ngFor="let c of comments">
      <strong>
        {{ c.user_name }}
      </strong>
      <p>{{ c.comment }}</p>
      <small>{{ c.created_at | date }}</small>
      <hr>
    </div>
  </div>

  <div class="trust-box row">
    <h6 class="text-primary"> {{ "trustshopping" | transloco }} </h6>

    <div class="col-6 col-md-3 mb-3" style="text-align: center;">
      <img src="/assets/e-commerce/icons/40.webp">
      <br>
      {{ "cashpayment" | transloco }}
    </div>
    <div class="col-6 col-md-3 mb-3" style="text-align: center;">
      <img src="/assets/e-commerce/icons/41.webp">
      <br>
      {{ "returns" | transloco }}
    </div>
    <div class="col-6 col-md-3 mb-3" style="text-align: center;">
      <img src="/assets/e-commerce/icons/42.webp">
      <br>
      {{ "cashback" | transloco }}
    </div>
    <div class="col-6 col-md-3 mb-3" style="text-align: center;">
      <img src="/assets/e-commerce/icons/43.webp">
      <br>
      {{ "trusttrans" | transloco }}
    </div>







  </div>

  <!-- الكمية -->
  <div class="quantity-controls cartpage">
    <button (click)="min(product);" class="btn btn-outline-secondary">-</button>
    <span>{{quantity}}</span>
    <button (click)="plus(product);" class="btn btn-outline-secondary">+</button>
  </div>

  <!-- زرار إضافة للسلة -->
  <button class="btn btn-add" [class.alert-error]="
    product?.is_daily_offer &&
    (dailyOfferState.progress$ | async)! <= 80
  " (click)="plus(product);$event.stopPropagation();">{{
    "addtocart" | transloco
    }}</button>
  <!-- SHARE BUTTON -->
  <div class="share-box" style="margin-bottom: 30px;">
    <button class="btn btn-add" (click)="toggleShare()">
      {{ 'Share' | transloco }}
    </button>

    <!-- SHARE ICONS ROW -->
    <div class="share-sheet mt-3" *ngIf="showShare">
      <div class="share-item" (click)="shareFacebook()">
        <img src="/assets/share/facebook.svg" />
        <span> {{ 'Facebook' | transloco }}</span>
      </div>

      <div class="share-item" (click)="shareWhatsApp()">
        <img src="/assets/share/whatsapp.svg" />
        <span>{{ 'WhatsApp' | transloco }}</span>
      </div>



      <div class="share-item" (click)="shareTelegram()">
        <img src="/assets/share/telegram.svg" />
        <span>{{ 'Telegram' | transloco }}</span>
      </div>


      <div class="share-item" (click)="copyShareLink()">
        <img src="/assets/share/link.svg" />
        <span>{{ 'Copy' | transloco }}</span>
      </div>
    </div>

  </div>

  <app-productrecommendation style="padding: 0!important;"></app-productrecommendation>
</div>